export default {
    excess: 'Povećano pokriće',
    security: 'Jamstveni polog',
    fuel_policy: 'Pravilo količine goriva',
    like_for_like: 'Koliko dobiješ toliko vraćaš',
    full_to_full: 'Dobiven i vraćen puni spremnik',
    mileage: 'Milje: {mileage} milja po najmu',
    unlimited_mileage: 'Neograničeno milja',
    non_refundable: 'Bespovratno',
    free_cancellation_until: 'Besplatno odustajanje do {date}',
    cancellation_with_terms: 'Odustajanje {0} u skladu s ',
    t_c_text: 'Uvjetima i odredbama',
    two_free_extras: 'Dva besplatna dodatka prilikom preuzimanja',
    glass_tyres_covered: 'Pokriće za stakla i gume'
}
